import { render, staticRenderFns } from "./PSupportWidget.vue?vue&type=template&id=9eab8354"
import script from "./PSupportWidget.vue?vue&type=script&lang=js"
export * from "./PSupportWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports